import { render } from "./AddTextBox.vue?vue&type=template&id=3b4fd7a2"
import script from "./AddTextBox.vue?vue&type=script&lang=js"
export * from "./AddTextBox.vue?vue&type=script&lang=js"

import "./AddTextBox.vue?vue&type=style&index=0&id=3b4fd7a2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__